<dr-header *ngIf="authService.loggedin"></dr-header>
<div class="maincontent">
  <app-alert></app-alert>
  <router-outlet></router-outlet>
</div>
<span defaultOverlayTarget></span>
